// Deterministic category colors — same list as server
export const CATEGORY_COLORS = [
  "#3b82f6", // blue
  "#8b5cf6", // violet
  "#ec4899", // pink
  "#f97316", // orange
  "#14b8a6", // teal
  "#eab308", // yellow
  "#06b6d4", // cyan
  "#f43f5e", // rose
  "#84cc16", // lime
  "#a855f7", // purple
];

export const STATUS_COLORS: Record<string, string> = {
  running: "#30d158", // Apple green
  idle: "#636366",    // Apple gray
  stopped: "#8e8e93", // Apple secondary gray
  failed: "#ff453a",  // Apple red
};
